import { SearchFilter } from '@aibees/elephant/feature/search-filters/types';
import { SearchBrowseParams, SearchTable } from '@aibees/elephant/types';
import { useMemo } from 'react';
import { getTags } from '../utils';
import { Maybe } from '@aibees/shared/definition';

export function useFiltersTags(
  searchTable: Maybe<SearchTable>,
  params: Partial<SearchBrowseParams>,
  filters: SearchFilter[]
) {
  return useMemo(
    () => filters?.map((filter) => getTags(params, filter)),
    [filters, params, searchTable]
  );
}
